var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { "justify-center": "", row: "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            fullscreen: "",
            "hide-overlay": "",
            persistent: "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.show,
            callback: function($$v) {
              _vm.show = $$v
            },
            expression: "show"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { id: "cardDivAsignacion" } },
            [
              _c(
                "CabeceraModal",
                {
                  attrs: {
                    titulo:
                      "Detalle Asignación " +
                      (_vm.registroSeleccionado
                        ? _vm.registroSeleccionado.asignumero
                        : "") +
                      " | " +
                      (_vm.registroSeleccionado
                        ? _vm.registroSeleccionado.asigrequerimiento
                        : "") +
                      " | " +
                      (_vm.registroSeleccionado
                        ? _vm.registroSeleccionado.rut_cliente
                        : "")
                  },
                  on: { cerrar: _vm.handleCerrar }
                },
                [
                  _c("NavegacionModalCrud", {
                    staticClass: "botonSeriado",
                    attrs: { pasos: _vm.pasos },
                    model: {
                      value: _vm.pasoActivoIndex,
                      callback: function($$v) {
                        _vm.pasoActivoIndex = $$v
                      },
                      expression: "pasoActivoIndex"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-card",
                { attrs: { flat: "", height: "55px" } },
                [
                  _c(
                    "v-bottom-nav",
                    {
                      attrs: {
                        active: _vm.pasos.informacionGeneral.step,
                        value: true,
                        absolute: "",
                        color: "transparent"
                      },
                      on: {
                        "update:active": function($event) {
                          return _vm.$set(
                            _vm.pasos.informacionGeneral,
                            "step",
                            $event
                          )
                        }
                      }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.pasos.informacionGeneral.visible,
                              expression: "pasos.informacionGeneral.visible"
                            }
                          ],
                          attrs: {
                            value: _vm.pasos.informacionGeneral.step,
                            color: "primary",
                            flat: ""
                          },
                          on: { click: _vm.handleInfoGeneral }
                        },
                        [
                          _c("span", [_vm._v("Detalle Asignación")]),
                          _c("v-icon", [_vm._v("info")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showInfo,
                      expression: "showInfo"
                    }
                  ],
                  staticClass: "cardnew",
                  attrs: { align: "center" }
                },
                [
                  _c("br"),
                  _c("v-card", { staticClass: "rounded-card flex sm10 md10" }, [
                    _c(
                      "div",
                      { staticClass: "flex sm10 md10" },
                      [
                        _c(
                          "v-container",
                          { attrs: { "grid-list-md": "" } },
                          [
                            _c(
                              "v-toolbar",
                              [
                                _c(
                                  "v-tabs",
                                  {
                                    attrs: { centered: "" },
                                    model: {
                                      value: _vm.tabs,
                                      callback: function($$v) {
                                        _vm.tabs = $$v
                                      },
                                      expression: "tabs"
                                    }
                                  },
                                  [
                                    _c("v-tabs-slider", {
                                      attrs: { color: "yellow" }
                                    }),
                                    _c("v-tab", [_vm._v("Requerimiento")]),
                                    _c("v-tab", [_vm._v("Archivo Solicitud")]),
                                    _c("v-tab", [_vm._v("Equipos Reservados")])
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "v-tabs-items",
                              {
                                model: {
                                  value: _vm.tabs,
                                  callback: function($$v) {
                                    _vm.tabs = $$v
                                  },
                                  expression: "tabs"
                                }
                              },
                              [
                                _c(
                                  "v-tab-item",
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "text-sm-right botones-filtros",
                                        staticStyle: { margin: "10px" }
                                      },
                                      [
                                        _vm.registroSeleccionado.estado ==
                                        "Por Reservar"
                                          ? _c(
                                              "v-btn",
                                              {
                                                staticStyle: {
                                                  "padding-right": "20px"
                                                },
                                                attrs: { color: "#ffe800" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.finalizarReq()
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticStyle: {
                                                      color: "black"
                                                    },
                                                    attrs: {
                                                      dark: "",
                                                      left: ""
                                                    }
                                                  },
                                                  [_vm._v("publish")]
                                                ),
                                                _vm._v(
                                                  "  \n                      "
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "black"
                                                    }
                                                  },
                                                  [_vm._v("Finalizar")]
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-card",
                                      { attrs: { flat: "" } },
                                      [
                                        _c("ModalRequerimiento", {
                                          attrs: { data: _vm.data }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-tab-item",
                                  [
                                    _c(
                                      "v-card",
                                      { attrs: { flat: "" } },
                                      [
                                        _c("AsignacionNoSeriado", {
                                          ref: "AsignacionNoSeriadoComponent",
                                          attrs: {
                                            regSeleccionado:
                                              _vm.registroSeleccionado
                                          },
                                          on: {
                                            updateValueEvidencia:
                                              _vm.updateValueEvidencia,
                                            updateValueEvidenciaResumen:
                                              _vm.updateValueEvidenciaResumen
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-tab-item",
                                  [
                                    _c(
                                      "v-card",
                                      { attrs: { flat: "" } },
                                      [
                                        _c("AsignacionSeriado", {
                                          attrs: {
                                            regSeleccionado:
                                              _vm.registroSeleccionado
                                          },
                                          on: {
                                            handleCerrar: _vm.handleCerrar,
                                            updateValueReserva:
                                              _vm.updateValueReserva,
                                            updateValueReservaResumen:
                                              _vm.updateValueReservaResumen,
                                            downloadExcel: _vm.downloadExcel,
                                            updateGrilla: _vm.updateGrilla
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }